// components/ProtectedRoute/ActivationRoute.jsx
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { CurrentUserContext } from "../../contexts/CurrentUserContext";
import { hasSessionToken } from "../../utilit/authSession";

function ActivationRoute({ element, isLogin, isReadyApp }) {
  const { currentUser } = useContext(CurrentUserContext);

  // Ждём завершения инициализации приложения
  if (!isReadyApp) {
    return null;
  }

  // Если не залогинен — отправляем на страницу входа
  if (!isLogin && !hasSessionToken()) {
    return <Navigate to="/sign-in" replace />;
  }

  // Если уже активирован — перенаправляем в контент
  if (currentUser?.isActivated) {
    return <Navigate to="/content" replace />;
  }

  // Иначе показываем страницу подтверждения
  return element;
}

export default ActivationRoute;
